export const DATE_OF_BIRTH_NAME = 'director_info.date_of_birth';
